module.exports = __webpack_public_path__ + "static/img/day-7.cc8d0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-7.png
// module id = YRUt
// module chunks = 1